import { FETCH_WITH_TOKEN } from '@services/react-query/config'
import { GET_USER_CART_URL } from '@services/react-query/urls/courses'
import { useQuery } from '@tanstack/react-query'
import { ShortCourse } from '@ugu/types'

const useGetUserCart = (enabled = false) => {
  const { ...data } = useQuery<ShortCourse[]>({
    queryKey: ['user-cart'],
    queryFn: () => FETCH_WITH_TOKEN(GET_USER_CART_URL()),
    enabled,
  })
  return data
}

export default useGetUserCart
